import React, {Component} from "react"

export default class TitleSection extends Component {
  render() {
    return (
      <div className={`sh-title-section ${this.props.className}`}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/decorators/TitleSection.js